export default __webpack_public_path__ + "static/media/companyLogo.3c10f767.png";